import { Button, Col, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import SpecialFinancingForm from './SpecialForm';
import SpecialFinancingHttpService from '../../../../services/http/special-financing-http';
import getValidationsErrors from '../../../../utils/getValidationsErrors';
import handleResponseError from '../../../../utils/handleResponseError';
import { StyledPageTitle, StyledPageSubTitle } from '../../BranchesData/styles';

const specialFinancingShema: Yup.ObjectSchema<{
    partnerBank: string;
    observation: string;
}> = Yup.object().shape({
    partnerBank: Yup.string()
        .required('Campo obrigatório')
        .max(30, 'Campo deve conter no máximo 30 caracteres'),
    observation: Yup.string().max(
        30,
        'Campo deve conter no máximo 30 caracteres',
    ),
});

export interface SpecialFinancingParams {
    id?: number;
    isEnabled: boolean;
    partnerBank: string;
    observation: string;
}

export default function SpecialFinancingData() {
    const form = useForm<SpecialFinancingParams>({
        defaultValues: {
            isEnabled: false,
            partnerBank: '',
            observation: '',
        },
    });
    const [errors, setErrors] = useState<any>({
        isEnabled: '',
        partnerBank: '',
        observation: '',
    });

    async function validateForm(formValues: any): Promise<boolean> {
        try {
            await specialFinancingShema.validate(formValues, {
                abortEarly: false,
            });

            setErrors({
                isEnabled: '',
                partnerBank: '',
                observation: '',
            });
            return true;
        } catch (error) {
            const err = error as any;

            setErrors({ ...errors, ...getValidationsErrors(err) });
            return false;
        }
    }

    async function handleSubmit(): Promise<void> {
        try {
            const data = form.getValues();
            const isValid = await validateForm(data);
            if (!isValid) return;

            await SpecialFinancingHttpService.update(data);

            toast.success(
                'Configuração de financiamento especial salva com sucesso!',
            );
        } catch (err) {
            handleResponseError(
                err,
                'Erro ao salvar configuração de financiamento especial',
            );
        }
    }

    async function loadConfig(): Promise<void> {
        try {
            const { data } = await SpecialFinancingHttpService.read();

            form.setValue('isEnabled', data.isEnabled ?? false);
            form.setValue('observation', data.observation || '');
            form.setValue('partnerBank', data.partnerBank || '');
        } catch (err) {
            handleResponseError(
                err,
                'Erro ao buscar configuração de financiamento especial',
            );
        }
    }

    const handleChanges = (event: any) => {
        const formValues: any = form.getValues();

        formValues[event.target.name] = event.target.value;

        if (event.target.name === 'isEnabled') {
            form.setValue('isEnabled', event?.target?.checked);
            return;
        }

        validateForm(formValues);
    };

    useEffect(() => {
        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Form.Group controlId="formSpecialFinancing">
            <Row className="align-items-center">
                <Col>
                    <StyledPageTitle className="mt-2">
                        Finaciamento Especial
                    </StyledPageTitle>
                    <StyledPageSubTitle>
                        Configuração para opção de financiamento especial nos
                        pedidos.
                    </StyledPageSubTitle>
                </Col>
                <Col className="text-right">
                    <Button
                        className="float-right w-25 m-2"
                        onClick={() => handleSubmit()}
                    >
                        Salvar
                    </Button>
                </Col>
            </Row>
            <Row className="mt-4 pl-2 pr-2">
                <Col>
                    <SpecialFinancingForm
                        formParams={form}
                        errors={errors}
                        handleChanges={handleChanges}
                    />
                </Col>
            </Row>
        </Form.Group>
    );
}
